import { environment } from "../environments/environment";

const CONFIG = {
    ...environment,
    amplify: {
        Auth: {
            region: 'us-west-2',
            userPoolId: 'us-west-2_3vKzzszQi', // your user pool ID
            idpURL: 'cognito-idp.us-west-2.amazonaws.com', // cognito idp url
            identityPoolId: 'us-west-2:a07866c5-2bea-45ca-afa9-b862f99723e9',
            userPoolWebClientId: '37ju533m82e1tmkrl3uvvv4jj5', // appId
        },
        Analytics: {
            disabled: false,
        },
        AWSKinesis: {
            region: 'us-west-2',
            disabled: false,
            bufferSize: 100,
            flushInterval: 5000,
            flushSize: 100,
            resendLimit: 5,
            streamName: "lem-event-data",
        },
    },
    // Sentry: {
    //     url: "https://393c4a14113841e6a6d80c1eee052803@sentry.epistemicanalytics.org/6",
    // },
    stakeholderGroups: [{
        name: "Local Business Consortium",
        info: "A prosperous community starts with a prosperous economy. More development means higher standards of living and better quality of life!",
    }, {
        name: "Environmental Advocacy Center",
        info: "This is the only planet we have, and we have a responsibility to be active stewards. The health of our community depends on the health of our environment!",
    }, {
        name: "Community Coalition",
        info: "Above all else, it’s people that make a community strong. We look after our kids and neighbors by making sure this is the best possible place to live and raise a family.",
    }],
    difficulties: [
        {
            "name": "Easy",
            "description": "Take more time to experiment with more requests to stakeholders.",
            "budget": 45,
        },
        {
            "name": "Medium",
            "description": "As you consider changes to your map, you can request feedback from different stakeholders.",
            "budget": 36,
            "default": true
        },
        {
            "name": "Hard",
            "description": "Challenge yourself with fewer requests for feedback.",
            "budget": 27,
        }
    ],

    preloadModules: true,
    scrollPadding: false,
    scrollAssist: true,
    autoFocusAssist: false,
    maps: {
        idle: {
            fillOpacity: 0.6,
            strokeOpacity: 0.8,
            strokeWeight: 1
        },
        active: {
            fillOpacity: 0.5,
            strokeOpacity: 0.8,
            strokeWeight: 3
        },
        inactive: {
            fillOpacity: 0.3,
            strokeOpacity: 0.6,
            strokeWeight: 1
        },
        zoomControl: true,
        styles: [
            { "featureType": "road.highway", "elementType": "geometry.fill", "stylers": [{ "color": "#ffffff" }, { "lightness": 17 }] },
            { "featureType": "road.highway", "elementType": "geometry.stroke", "stylers": [{ "color": "#ffffff" }, { "lightness": 29 }, { "weight": 0.2 }] },
            { "featureType": "road.arterial", "elementType": "geometry", "stylers": [{ "color": "#ffffff" }, { "lightness": 8 }] },
            { "featureType": "road.local", "elementType": "geometry", "stylers": [{ "visibility": "off" }, { "lightness": 4 }] },
            { "featureType": "road.local", "elementType": "labels", "stylers": [{ "visibility": "off" }] },
            { "featureType": "poi", "elementType": "geometry.fill", "stylers": [{ "visibility": "off" }] } ,
            { "featureType": "poi", "elementType": "labels", "stylers": [{ "visibility": "off" }] },
            { "featureType": "transit", "elementType": "all", "stylers": [{ "visibility": "off" }] }
        ]
    },
    optimize: {
        //timeout: 60000,
        timeout: -1,
        parcel_count: 200,
        min_parcel_count: 150,
    },
    start: {
        location: {
            lat: 43.0730517,
            lng: -89.40123019999999,
        },
        zoom: 14,
    },
    indicatorCount: 5,
    stakeholderGroupSize: 3,
    error_codes: {
        ui: "radish",
        timeout: "onion",
    },
    register: {
        username: {
            min_length: 3,
        },
        password: {
            min_length: 6,
        },
    },
};

export default CONFIG;
